import Vue from "vue";
import {API_HOST} from "@/settings/server";
import $store from "@/store";
import axios from "axios";

class TemplateService {
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
    }

    cancelRequests() {
        this.cancelTokenSource.cancel('GET requests canceled by the user.');
        this.cancelTokenSource = axios.CancelToken.source();
    }

    getTemplates({organizationId}){
        return Vue.axios.get(`${API_HOST}/api/template`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                organizationId: organizationId === null || typeof organizationId === 'undefined' ? null : organizationId
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    getTemplate({id}){
        return Vue.axios.get(`${API_HOST}/api/admintemplate`, {
            headers: {
                'Authorization': `Bearer ${$store.getters.accessToken}`
            },
            params: {
                id: id === null || typeof id === 'undefined' ? null : id
            },
            cancelToken: this.cancelTokenSource.token,
        })
    }

    mapTemplate(fileName, keys, firstSheetData, isTemplateNameFromExcel){
        const registryRequest = {
            Mails: []
        };

        firstSheetData.slice(1).forEach(row => {
            const mailRequest = {
                Receiver: row["receiver"],
                RegionId: parseInt(row["region"]),
                AreaId: parseInt(row["area"]),
                Address: row["address"],
                TemplateName: !isTemplateNameFromExcel ? fileName : row["template_name"],
                Content: this.createJsonContent(row)
            };

            console.log(mailRequest);

            registryRequest.Mails.push(mailRequest);
        });

        return registryRequest;
    }

    createJsonContent(rowData) {
        delete rowData.receiver;
        delete rowData.region;
        delete rowData.area;
        delete rowData.address;

        return JSON.stringify(rowData);
    }
}

export default new TemplateService()
